export const TEXTS = {
  INVOICE_TEXT: 'Оплата по счету',
};
